<template>
  <div>
    <div class="search">
      <p>扫码后您可以使用手机进行测评：</p>
    </div>
    <div class="table">
      <div class="type">扫码测评</div>
      <div class="code">
        <div class="past" v-show="isTestCodeTime">二维码已过期</div>
        <p>扫描二维码，可使用手机版测评</p>
        <img :src="codeUrl" ref="code" alt />
        <br />
        <button @click="saveCodeImg()">保存二维码到本地</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codeType: "",
      codeUrl: "",
    };
  },
  methods: {
    async getSetting() {
      const { data } = await this.$post("api/system/config/info", {
        status: 1,
      });
      let twoCodeLogin = data.data.list.can_qrcode_login == 1 ? true : false;
      let dateStartValue = data.data.list.qrcode_login_startdate;
      let dateEndValue = data.data.list.qrcode_login_enddate;
      let scanQRCodes = data.data.list.can_qrcode_test == 1 ? true : false;
      let dateCodesStartValue = data.data.list.qrcode_test_startdate;
      let dateCodesEndValue = data.data.list.qrcode_test_enddate;
      this.$store.commit("setCode", {
        logo: [dateStartValue, dateEndValue], 
        isLogo: twoCodeLogin, 
        test: [dateCodesStartValue, dateCodesEndValue], 
        isTest: scanQRCodes,
      });
    },
    async getCodeType() {
      let { data } = await this.$post("api/system/QR/getQRType");
      this.codeType = data.data.list.type;
      this.getCode();
    },
    async getCode() {
      let cip = "";
      try {
        cip = `http://${/([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(FingerprintObj.getLocalIp())[0]}`;
      } catch (error) {
        cip = this.global.ip.replace(/:[0-9]+/, '');
      }
      let data = await this.$post("api/system/QR/getLoginQR", {
        lanIP: cip,
        type: this.codeType,
        status: 2,
      });
      this.codeUrl = JSON.stringify(data.data.data.list.qr.thumb);
      this.codeUrl = JSON.parse(this.codeUrl);
    },
    //保存二维码到本地
    saveCodeImg() {
      if (this.isTestCodeTime) {
        return;
      }
      var img = this.$refs.code;
      var url = img.src;
      var a = document.createElement("a");
      //var event = new MouseEvent("click");
      a.download = "二维码";
      a.href = url;
      //a.dispatchEvent(event);
      a.click();
      // let url = this.global.ip + this.codeUrl + "?" + +new Date();
      // let image = new Image();
      // image.setAttribute("crossOrigin", "anonymous"); //解决跨域
      // console.log(image);
      // image.crossOrigin = "*";
      // image.src = url;
      // let _this = this;
      // image.onload = function () {
      //   let base64 = _this.getUrlBase64(image);
      //   console.log(base64);
      // };
    },
    // getUrlBase64(img) {
    //   let canvas = document.createElement("canvas");
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   let ctx = canvas.getContext("2d");
    //   ctx.drawImage(img, 0, 0, img.width, img.height);
    //   let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
    //   let dataURL = canvas.toDataURL("image/" + ext);
    //   return dataURL;
    // },
  },
  computed: {
    isTestCodeTime() {
      if (!this.$store.state.testCode) {
        return true
      }
      let starttime = this.$store.state.testCodeTime[0];
      let endtime = this.$store.state.testCodeTime[1];
      if (
        +new Date(starttime) > +new Date() ||
        +new Date(endtime) < +new Date()
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getSetting()
    this.getCodeType();
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 20px;
  height: 770px;
  width: 1430px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  .type {
    height: 60px;
    background: #f0f0f0;
    text-align: center;
    color: #555555;
    line-height: 60px;
  }
  .code {
    text-align: center;
    .past {
      position: absolute;
      font-size: 26px;
      height: 200px;
      width: 200px;
      background: rgba(255, 255, 255, 0.8);
      box-sizing: border-box;
      padding-top: 80px;
      top: 470px;
      left: 670px;
    }
    p {
      margin: 139px 0 29px 0;
    }
    img {
      width: 200px;
      height: 200px;
    }
    button {
      height: 46px;
      width: 200px;
      background: #3170ff;
      color: #fff;
      border: 0;
      border-radius: 6px;
      margin-top: 35px;
    }
  }
}
</style>